import axios from "axios";


export const BaseURL = 'https://mahaarch.backend.fresherszone.in';

 export const createIntance=axios.create({
     baseURL: BaseURL,
    withCredentials: true
})

const Connection=async()=>{
try{
    const response=await createIntance.get("/admin/upload/cheackconnection");
   console.log('Connection successful:', response.data);

}
catch(error){
 console.error('Connection failed:', error);
}
}

Connection();
export default createIntance;
